/* eslint-disable eslint-comments/disable-enable-pair -- kendo skeleton */
/* eslint-disable @typescript-eslint/no-deprecated -- kendo skeleton */
import { Skeleton } from "@tql/ui-components-react/kendo/indicators";
import {
	Card,
	CardBody,
	CardTitle,
} from "@tql/ui-components-react/kendo/layout";
import type { KeyboardEvent } from "react";

import { camelToTitle } from "~/shared/utils/string-fns.ts";

import { ExceptionIndicator } from "../exceptions-indicator/exceptions-indicator.tsx";
import styles from "./summary-stat.module.css";

export const SummaryStat = ({
	createClickHandler,
	handleKeyDown,
	exceptionCounts,
	onClickSummaryCard,
	displayValue,
	todaysShipmentsNotDispatched,
	summary,
	cardType,
	isLoading,
	isActive,
}: {
	createClickHandler: (
		status: string,
		needsImmediateAction: boolean,
	) => () => void;
	handleKeyDown: (
		e: KeyboardEvent<Element>,
		status: string,
		needsImmediateAction: boolean,
	) => void;
	exceptionCounts: {
		notDispatched: number;
		dispatched: number;
		inTransit: number;
		delivered: number;
	};
	onClickSummaryCard: (status: string, needsImmediateAction: boolean) => void;
	displayValue: (
		count: number,
		isDefault: boolean | undefined,
	) => number | string;
	todaysShipmentsNotDispatched: { count: number; exceptionsCount: number };
	summary: { isDefault?: boolean };
	cardType: string;
	isLoading: boolean;
	isActive: boolean;
}) => {
	const formattedCardName = {
		title: camelToTitle(cardType.replaceAll("future", "")),
		fullName: camelToTitle(cardType),
	};
	const hasExceptions =
		(exceptionCounts[cardType as keyof typeof exceptionCounts] ?? 0) > 0;
	const cardClassNames = [styles.smallCard];
	if (isActive) {
		cardClassNames.push(styles.activeCard);
		if (hasExceptions) {
			cardClassNames.push(styles.activeCardException);
		}
	}
	return (
		<Card
			aria-label={`Filter to show ${formattedCardName.fullName} shipments`}
			className={cardClassNames.join(" ")}
			onClick={createClickHandler(cardType, false)}
			onKeyDown={(e: KeyboardEvent<Element>) =>
				handleKeyDown(e, cardType, false)
			}
			role={"button"}
			tabIndex={0}
		>
			<CardTitle>
				<div className={styles.cardTitleRow}>
					<div>{formattedCardName.title}</div>
					{!isLoading && (
						<ExceptionIndicator
							count={exceptionCounts[cardType as keyof typeof exceptionCounts]}
							exceptionType={cardType}
							isActive={isActive}
							onClickSummaryCard={onClickSummaryCard}
						/>
					)}
				</div>
			</CardTitle>
			<CardBody className={styles.value}>
				{isLoading ? (
					<Skeleton
						animation={{ type: "wave" }}
						shape={"rectangle"}
						style={{ width: "35%", height: "1em", borderRadius: 3 }}
					/>
				) : (
					displayValue(todaysShipmentsNotDispatched.count, summary.isDefault)
				)}
			</CardBody>
		</Card>
	);
};
